import Flex from "../../../../../../../../../../../components/Flex";
import AssessmentDrawer from "../../../../../../../../scheduling/appointment/encounter/Assessment/AssessmentDrawer";
import StyledPopoverButton from "../../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledPopoverButton";
import PreviewScreener from "../../../../../../../../scheduling/appointment/encounter/default-forms/form-2/ScreenerPreview";
import { DapScreening } from "./use-dap-screening";

// Same "Add Screening" popover, assessment drawer and submitted-screener
// preview the Psychiatric Note uses in its Objective section — split in two so
// the button can sit next to "Add ICD Codes" while the submitted screeners are
// listed further down the Assessment section.
interface DapScreeningProps {
  screening: DapScreening;
}

/** "Add Screening" popover button — rendered inline with "Add ICD Codes". */
export const DapScreeningButton = ({ screening }: DapScreeningProps) => (
  <StyledPopoverButton
    disableStartIcon
    w="140px"
    onClick={(v) => screening.screeningDisclosure.open(v)}
    options={screening.screenerList ?? []}
    label="Add Screening"
    instantSearchStringKey={screening.instantSearchStringKey}
    setSearchStringKey={screening.setSearchStringKey}
  />
);

/** Submitted screeners (name, score, severity, date) + the assessment drawer. */
export const DapScreeningPreview = ({ screening }: DapScreeningProps) => {
  const hasScreeners = !!Object.keys(
    (screening.screeners ?? {}) as Record<string, unknown>
  ).length;

  return (
    <>
      {hasScreeners && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          <PreviewScreener
            onEdit={(it) => {
              screening.screeningDisclosure.open(it);
            }}
            dataListObj={screening.screeners}
          />
        </Flex>
      )}
      <AssessmentDrawer disclosureHost={screening.screeningDisclosure} />
    </>
  );
};
